import Image from "next/image";
import { useEffect, useState } from "react"

export const FallBackImage = ({ src, alt, ...rest }) => {
    const [imgSrc, setImgSrc] = useState(src);
    useEffect(() => { setImgSrc(src); }, [src]);

    const imageSrc = imgSrc ? imgSrc : '/img/no-image.jpeg';

    // If width/height aren't provided, use `fill` so Image doesn't error
    const hasSize = rest.width || rest.height || rest.fill;
    const imageProps = {
        ...rest,
        alt,
        src: imageSrc,
        onError: () => { setImgSrc('/img/no-image.jpeg') }
    };

    if (!hasSize) {
        imageProps.fill = true;
        // ensure a sensible default objectFit when filling
        if (!imageProps.style) imageProps.style = { objectFit: 'cover' };
        else if (!imageProps.style.objectFit) imageProps.style.objectFit = 'cover';
    }

    return (
        <Image {...imageProps} />
    )
}